import * as redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/do'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/mapTo'
import * as App from '../../app'
import * as RootConstants from '../../constants'
import {ApplicationState} from '../../rootReducer'
import * as Router from '../../router'

export const onEnter = (
  action$: ReduxObservable.ActionsObservable<redux.Action>,
  store: redux.Store<ApplicationState>,
  {history, localStorage}: App.Dependencies,
) => action$.ofType(App.INITIALIZING_APPLICATION, Router.LOCATION_CHANGE)
  .filter(() => history.location.pathname.startsWith('/login'))
  .filter(() => !Boolean(localStorage.getItem(RootConstants.ACCESS_TOKEN)))
  .map(() => Router.redirect(store.getState().config.api.origin + '/auth/login'))

export const afterAuthenticateRedirect = (
  action$: ReduxObservable.ActionsObservable<redux.Action>,
  store: redux.Store<ApplicationState>,
  {history, localStorage}: App.Dependencies,
) => action$.ofType(App.INITIALIZING_APPLICATION, Router.LOCATION_CHANGE)
  .filter(() => history.location.pathname.startsWith('/login'))
  .filter(() => Boolean(localStorage.getItem(RootConstants.ACCESS_TOKEN)))
  .map(() => localStorage.getItem(RootConstants.REDIRECT_TO))
  .do(() => localStorage.removeItem(RootConstants.REDIRECT_TO))
  .map((redirectTo) => Router.redirect(redirectTo || '/'))

export const epic = ReduxObservable.combineEpics(
  onEnter,
  afterAuthenticateRedirect,
)



// WEBPACK FOOTER //
// ./src/pages/login/epic.ts